export default __webpack_public_path__ + "static/media/night_half_moon_clear.bf8dc6ce.svg";